/**
 * @public
 */
export var Scope;
(function (Scope) {
    /**
     * {@link https://html.spec.whatwg.org/#attr-th-scope}
     */
    function from(element) {
        return element
            .attribute("scope")
            .flatMap((attribute) => attribute.enumerate("row", "rowgroup", "col", "colgroup"))
            .map((scope) => {
            switch (scope) {
                case "row":
                    return "row";
                case "rowgroup":
                    return "row-group";
                case "col":
                    return "column";
                case "colgroup":
                    return "column-group";
            }
        })
            .getOr("auto");
    }
    Scope.from = from;
})(Scope || (Scope = {}));
//# sourceMappingURL=scope.js.map